import React, { Component } from "react";
// import axios from "axios";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
import myplexAPI from "../../api/myplexAPI";
// import { Link } from "react-router-dom";
// // import Img from "../Uicomponents/Img";
// import Img from "../../utils/similarContentImg";
// // import { slugify } from "../../utils/stringSlugify";
// import { slugify } from "../../../commonfiles/stringSlugify";
// // import { carouselPatnerLogos } from "../../utils/partnerLogos";
// // import LazyLoad from "react-lazyload";
// // import {getURLName} from "../../utils/urlMenu";
// import { getURLName } from "../../../commonfiles/urlMenu";

// import { genres,languages } from "../../utils/portalhelper";
// import sessionFun from "../../../commonfiles/SessionStorage";
import Recommended from "./Recommended";

export default class MovieCarosuls extends Component {
  state = {
    contents: [],
    pageName: "Home",
    trackingId: "",
  };
  componentDidMount() {
    {
      this.props.ContentId && this._getMovieCarosuls();
    }
    const page_name = window.location.pathname.split("/")[1];
    if (page_name !== "") {
      this.setState({
        pageName: page_name,
      });
    }
  }
  componentDidUpdate(prevProps) {
    if (prevProps.ContentId !== this.props.ContentId) {
      this._getMovieCarosuls();
    }
  }

  _getMovieCarosuls() {
    myplexAPI
      .pullPageData("movieDetailsPageWebReco", "", "")
      .then((response) => {
        // console.log(response);
        // if (this._isMounted) {
        this.setState({ contents: response.data.results });
        // }
      });
  }
  _getContent = () =>
    this.state.contents.map((content, i) => {
      return (
        <Recommended
          key={i}
          info={this.props.info}
          ContentId={this.props.ContentId}
          tvepisode={this.props.tvepisode}
          seriestags={this.props.seriestags}
          type={"Myreco"}
          MyrecoData={content}
          carosulcount = {i+1}
        />
      );
    });
  // this.state.contents.map((content, i) => {
  //   // console.log(content)
  //   // let logo = null;
  //   // if (content.publishingHouse !== undefined) {
  //   //   let partnerLogos = carouselPatnerLogos(
  //   //     content.publishingHouse.publishingHouseName
  //   //   );
  //   //   if (partnerLogos.link !== undefined) {
  //   //     logo = (
  //   //       <LazyLoad once>
  //   //         <img
  //   //           src={partnerLogos.link}
  //   //           alt={partnerLogos.name}
  //   //           className="you_may_like_logo_patner"
  //   //         />
  //   //       </LazyLoad>
  //   //     );
  //   //   }
  //   // }
  //   if(content.generalInfo.type=="tvepisode"){

  //     var beautifytitle = content.generalInfo.title && content.generalInfo.title.split("|");
  //     var t = beautifytitle[0];
  //     if(beautifytitle[1]){
  //       t = t+ beautifytitle[1] ;

  //    }
  //     var url = `/${getURLName(content, this.state.pageName)}/detail/${content.generalInfo._id}/${slugify(content.globalServiceName)}/${slugify(t)}`;
  //  }
  //  else {

  //    var url =  `/${getURLName(content, this.state.pageName)}/detail/${content.generalInfo._id}/${slugify(content.generalInfo.title)}`;
  //  }
  //   if(content._id!==this.props.ContentId) {
  //     return (
  //       <div key={i}>
  //         <Link
  //           to={{
  //             pathname: url,
  //           }}
  //           key={i}
  //         >
  //           {/* {!content.generalInfo.isSellable &&
  //             content.generalInfo.contentRights &&
  //             content.generalInfo.contentRights[0] === "avod" && (
  //               <div className="carousel_freetag">
  //                 <img src={carousel_freetag} alt="carousel_freetag" />
  //               </div>
  //             )} */}
  //           <div className="recommended_data" onClick={() => this.sourceDetails(i,content.generalInfo._id,this.state.pageName)} >
  //             <Img caroselimg={content} key={i} />
  //             {/* {logo} */}
  //           </div>
  //           <div className="episodes-info">
  //             <span> {content.generalInfo.title}</span>
  //           </div>
  //         </Link>
  //       </div>
  //     );
  //   }else {
  //     return null ;
  //   }

  // });
  // sourceDetails = (i,id,pageName) => {
  //   setTimeout(function () {
  //   localStorage.setItem("source details", "recommended");
  //   localStorage.setItem("trackingId", "");
  //   localStorage.getItem("os", "web");
  //       // localStorage.setItem("source", this.props.caroselinfo.title);
  //   localStorage.setItem("source", "carousel");
  //   sessionFun(
  //     // this.props.carousel_count,
  //     i ,
  //     1,
  //     pageName,
  //     "recommended",
  //     "recommended",
  //     id
  //   );

  // }, 5000); };

  render() {
    return this.props.info &&
      this.props.info.generalInfo &&
      this.props.info.generalInfo.type == "movie" &&
      this.state.contents.length > 0 ? (
      <div> {this._getContent()}</div>
    ) : null;
  }
}
